import { appendIf } from '@btime/helpers'
import { compose, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import { accountsClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertUser($input: UserInput) {
    upsertUser(input: $input) {
      id
      name
    }
  }
`

const cleanRequest = compose(
  pick(['id', 'password']) //
)

const validate = (form, setErrors, t) => {
  const errors = [
    ...appendIf(!form.password, {
      path: ['password'],
      message: t('passwordRequired')
    }),
    ...appendIf(!!form.password && form.password.length < 4, {
      path: ['password'],
      message: t('minCharacters', { count: 4 })
    }),
    ...appendIf(!!form.password && form.password !== form.passwordConfirmation, {
      path: ['passwordConfirmation'],
      message: t('passwordsDoNotMatch')
    })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveUser = () => {
  const { t } = useTranslation('editUser')
  const closeModal = useCloseModal()

  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Users'], client: accountsClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)
    const { setErrors } = actions
    const isValid = validate(form, setErrors, t)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
